/* Floodlight · product page (commerce). Qty x price label, variant change, size guide opener, "Added to cart" label, media thumbs.
   Adding to cart itself is handled by ss-cart.js (form[data-product-form]). No dependencies. */
(function () {
  if (window.SS_LOADED_product) return;
  window.SS_LOADED_product = true;

  var TYPE = 'main-product';

  function SSx() { return window.SS || {}; }

  function money(cents) {
    var S = SSx();
    if (typeof S.money === 'function') return S.money(cents);
    return 'Rs ' + Math.round((cents || 0) / 100).toLocaleString('en-US');
  }

  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }

  function rootOf(el) {
    if (!el) return null;
    if (el.matches && el.matches('[data-section-type="' + TYPE + '"]')) return el;
    return el.querySelector ? el.querySelector('[data-section-type="' + TYPE + '"]') : null;
  }

  function init(el) {
    var root = rootOf(el);
    if (!root || root.__ssInit) return;
    root.__ssInit = true;

    var form = root.querySelector('form[data-product-form]');
    var btn = root.querySelector('[data-add-main]');
    var qtyIn = form ? form.querySelector('input[name="quantity"]') : null;
    var select = root.querySelector('[data-variant-select]');
    var modal = document.getElementById('ss-size-guide');
    var stageImg = root.querySelector('.pdp-stage img');
    var labels = {
      add: btn ? btn.getAttribute('data-label-add') : 'Add to cart',
      added: btn ? btn.getAttribute('data-label-added') : 'Added to cart',
      sold: btn ? btn.getAttribute('data-label-sold') : 'Sold out'
    };
    var unit = btn ? parseInt(btn.getAttribute('data-unit-price'), 10) || 0 : 0;
    var available = btn ? !btn.disabled : true;
    var addedTimer = null;
    var cleanups = [];

    function on(target, type, fn, opts) {
      target.addEventListener(type, fn, opts);
      cleanups.push(function () { target.removeEventListener(type, fn, opts); });
    }

    function qty() {
      var v = parseInt(qtyIn && qtyIn.value, 10);
      if (!(v >= 1)) v = 1;
      return Math.min(99, v);
    }

    function renderTotal() {
      each(root.querySelectorAll('[data-line-total]'), function (t) { t.textContent = money(unit * qty()); });
    }

    function setLabel(text) {
      each(root.querySelectorAll('[data-add-label]'), function (l) { l.textContent = text; });
    }

    function setAvailable(av) {
      available = av;
      each(root.querySelectorAll('[data-add-main], [data-sticky-add]'), function (b) { b.disabled = !av; });
      each(root.querySelectorAll('[data-total-part]'), function (p) { p.hidden = !av; });
      setLabel(av ? labels.add : labels.sold);
    }

    /* quantity → button total (core stepper changes the value; fall back to our own step if it did not) */
    if (form && qtyIn) {
      on(form, 'input', function (e) { if (e.target === qtyIn) renderTotal(); });
      on(form, 'change', function (e) {
        if (e.target !== qtyIn) return;
        if (String(qty()) !== qtyIn.value) qtyIn.value = qty();
        renderTotal();
      });
      on(form, 'click', function (e) {
        var step = e.target.closest ? e.target.closest('[data-qty-step]') : null;
        if (!step || !form.contains(step)) return;
        var before = qtyIn.value;
        var delta = parseInt(step.getAttribute('data-qty-step'), 10) || 0;
        setTimeout(function () {
          if (qtyIn.value === before) {
            var min = parseInt(qtyIn.min, 10) || 1;
            var max = parseInt(qtyIn.max, 10) || 99;
            var next = Math.max(min, Math.min(max, (parseInt(before, 10) || 1) + delta));
            if (String(next) !== before) qtyIn.value = next;
          }
          renderTotal();
        }, 0);
      });
    }

    /* variants (only rendered when a product has real options) */
    var variants = [];
    var vEl = root.querySelector('script[data-variants]');
    if (vEl) { try { variants = JSON.parse(vEl.textContent) || []; } catch (err) { variants = []; } }

    function chosenOptions() {
      var chosen = [];
      each(root.querySelectorAll('[data-option-index]'), function (fs) {
        var c = fs.querySelector('input:checked');
        chosen[parseInt(fs.getAttribute('data-option-index'), 10)] = c ? c.value : null;
      });
      return chosen;
    }

    function markOff(chosen) {
      each(root.querySelectorAll('[data-option-index]'), function (fs) {
        var idx = parseInt(fs.getAttribute('data-option-index'), 10);
        each(fs.querySelectorAll('input[data-option-radio]'), function (input) {
          var ok = variants.some(function (v) {
            if (!v.available || v.options[idx] !== input.value) return false;
            return v.options.every(function (o, i) { return i === idx || chosen[i] == null || o === chosen[i]; });
          });
          input.parentNode.classList.toggle('is-off', !ok);
        });
      });
    }

    function onOption() {
      var chosen = chosenOptions();
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.options.every(function (o, k) { return chosen[k] == null || o === chosen[k]; })) { match = v; break; }
      }
      markOff(chosen);
      if (!match) { setAvailable(false); return; }
      if (select) select.value = String(match.id);
      unit = match.price;
      each(root.querySelectorAll('[data-variant-price]'), function (p) { p.textContent = money(match.price); });
      each(root.querySelectorAll('[data-variant-compare]'), function (c) {
        var show = match.compare_at_price && match.compare_at_price > match.price;
        c.hidden = !show;
        c.textContent = show ? money(match.compare_at_price) : '';
      });
      if (btn) btn.setAttribute('data-unit-price', match.price);
      setAvailable(!!match.available);
      renderTotal();
      if (stageImg && match.featured_image && match.featured_image.src) {
        stageImg.removeAttribute('srcset');
        stageImg.src = match.featured_image.src;
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (err) { /* ignore */ }
    }

    if (variants.length) {
      on(root, 'change', function (e) { if (e.target.matches && e.target.matches('input[data-option-radio]')) onOption(); });
      markOff(chosenOptions());
    }

    /* "Added to cart" state after a successful add from this form */
    on(document, 'ss:cart:updated', function (e) {
      var d = e.detail || {};
      if (d.action && d.action !== 'add') return;
      var src = d.source;
      if (!src || !(src === form || root.contains(src) || (src.form && src.form === form))) return;
      setTimeout(function () {
        setLabel(labels.added);
        if (qtyIn) { qtyIn.value = 1; renderTotal(); }
        clearTimeout(addedTimer);
        addedTimer = setTimeout(function () { setLabel(available ? labels.add : labels.sold); }, 1800);
      }, 0);
    });

    /* size guide: core opens [data-open-overlay]; open it here only if nothing did */
    var sgBtn = root.querySelector('[data-size-guide]');
    if (sgBtn && modal) {
      on(sgBtn, 'click', function () {
        setTimeout(function () {
          if (!modal.hidden) return;
          var S = SSx();
          if (S.overlay && typeof S.overlay.open === 'function') { S.overlay.open('ss-size-guide', { trigger: sgBtn }); return; }
          var scrim = modal.previousElementSibling;
          function close() {
            modal.hidden = true;
            if (scrim) scrim.hidden = true;
            document.removeEventListener('keydown', onKey);
            sgBtn.focus();
          }
          function onKey(ev) { if (ev.key === 'Escape') close(); }
          if (scrim) { scrim.hidden = false; scrim.onclick = close; }
          modal.hidden = false;
          each(modal.querySelectorAll('[data-close-overlay]'), function (c) { c.onclick = close; });
          document.addEventListener('keydown', onKey);
          modal.focus();
        }, 60);
      });
    }

    /* extra media thumbnails */
    each(root.querySelectorAll('.pdp-thumb'), function (t) {
      on(t, 'click', function () {
        if (!stageImg) return;
        var srcset = t.getAttribute('data-srcset');
        if (srcset) stageImg.setAttribute('srcset', srcset); else stageImg.removeAttribute('srcset');
        stageImg.src = t.getAttribute('data-src');
        stageImg.alt = t.getAttribute('data-alt') || stageImg.alt;
        each(root.querySelectorAll('.pdp-thumb'), function (o) { o.setAttribute('aria-current', o === t ? 'true' : 'false'); });
      });
    });

    renderTotal();

    return function destroy() {
      clearTimeout(addedTimer);
      each(cleanups, function (fn) { fn(); });
      root.__ssInit = false;
    };
  }

  function boot() {
    var S = SSx();
    if (typeof S.sectionReady === 'function') {
      S.sectionReady(TYPE, init);
    } else {
      each(document.querySelectorAll('[data-section-type="' + TYPE + '"]'), init);
      document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
